module.exports = __webpack_public_path__ + "static/img/code.e2e15aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/code.jpg
// module id = sxUQ
// module chunks = 16